import React from 'react';
import { ConfirmEmail as ConfirmEmailModule } from '@dev/ee-modules';
import { ProductCode } from '@dev/ee-api/ee-api-models';
import { HomePaths } from '@api/services/dictionaries/paths';
import { ResendActivationEmail } from '@api/store/auth/actions';
import { ShowToast } from '@api/store/toast/actions';

export const ConfirmEmail = () => (
    <ConfirmEmailModule
        paths={{ Home: HomePaths.Home, ConfirmEmail: HomePaths.ConfirmEmail }}
        productCode={ProductCode.EmailApi}
        ResendActivationEmail={ResendActivationEmail}
        ShowToast={ShowToast}
    />
);
